import { Activity } from 'lucide-react'
import { DnsblPanel } from '@/components/deliverability/dnsbl-panel'
import { IspReputationPanel } from '@/components/deliverability/isp-reputation-panel'
import { DeliverabilityMetrics } from '@/components/deliverability/metrics-row'
import { SeedAccountsPanel } from '@/components/deliverability/seed-accounts-panel'
import { SeedTestPanel } from '@/components/deliverability/seed-test-panel'
import { useSeedAccounts, useSeedResults } from '@/hooks/use-deliverability'
import { useEngineHealth } from '@/hooks/use-engine'

export function DeliverabilityPage(): React.JSX.Element {
  const healthQuery = useEngineHealth()
  const seedsQuery = useSeedAccounts()
  const resultsQuery = useSeedResults(1)

  const seeds = seedsQuery.data?.data ?? []
  const testRuns = resultsQuery.data?.data ?? []

  // Calculate inbox rate from seed results.
  const recentSeeds = seeds.filter((s) => s.last_result !== null)
  const inboxCount = recentSeeds.filter((s) => s.last_result === 'inbox').length
  const inboxRate = recentSeeds.length > 0 ? Math.round((inboxCount / recentSeeds.length) * 100) : 0

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex items-center gap-3">
        <Activity className="h-6 w-6 text-admin-500" />
        <h1 className="text-2xl font-semibold text-text-primary">Deliverability</h1>
      </div>

      {/* Top metrics row */}
      <DeliverabilityMetrics
        inboxRate={inboxRate}
        seedCount={recentSeeds.length}
        queueDepth={healthQuery.data?.queue_depth ?? 0}
        isLoading={seedsQuery.isLoading || healthQuery.isLoading}
      />

      {/* Seed test results */}
      <SeedTestPanel testRuns={testRuns} isLoading={resultsQuery.isLoading} />

      {/* Seed accounts management */}
      <SeedAccountsPanel seeds={seeds} isLoading={seedsQuery.isLoading} />

      {/* DNSBL status */}
      <DnsblPanel />

      {/* ISP reputation panel */}
      <IspReputationPanel />
    </div>
  )
}
